import { makeEntityScaffold } from '@classpass/saga-tools';
import urls from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';

const handler = ({ httpClient }, payoutId) => {
  const endpoint = urls.reports.invoiceStatus(payoutId);
  return httpClient.get(endpoint).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.PAYOUT_INVOICE_STATUS', handler);
